import {FieldController} from "./elements.field.controller";




var moment = require('moment');


class inputDatePickerController  extends FieldController  {

    static get $inject(){ return   ["$element", '$log', '$scope']}
    static get dateMask(){return "__.__.____"}
    constructor($element, $log, $scope) {
        super($log, $scope, $element)
        this.$element = $element;
        this.placeholder =  "Укажите дату";
        this._model=null;
        this.timer = null;
        this.masked  =false;
        this.selectDate = null;
        this.isChanged = false;
    }

    get model (){
        //console.warn('DatePicker::'+this.fieldName+'::get model ', this._model);
        
        var date = null ; 
        
       
        

        switch (this.outputType){
            case 'iso':
                if(this._model.indexOf('-')>-1){
                    date = moment(this._model);
                }else{
                    date = moment(this._model, 'DD.MM.YYYY')
                }

                return date.toISOString();
            default:
                return this._model;
        }
       
    }
    

    set model(value){

       // console.warn('DatePicker::'+this.fieldName+'::set model ', value);
        this._model = value ; 
        

        if(!value){
            this.selectDate  = null ;
            this.date = '';
            return
        }


        var date = null ; 
        
        if(value.indexOf('-')>-1){
            date = moment(value);
        }else{
            date = moment(value, 'DD.MM.YYYY')
        }

        
        if(!date){
            return ;
        }

        if(!date.isValid()){
            debugger
            return 
        }

        this.selectDate  = date;
        this.haveError = false;
        this.setDate()
        this.setDateInput();
        

    }


    setDateInput(){
        this.date = this.selectDate.format('DD.MM.YYYY');
    }

    setDate(){
        if(!this.$datepicker){
            return 
        }
        if(!this.selectDate){
            return 
        }

        if(this.selectDate.year()<1900){
            return 
        }

        if(this.selectDate.year()>2100){
            return 
        }

        this.$datepicker.selectDate( this.selectDate.toDate())
    }
   
    setDateFromInput(value){
    
        if(value.indexOf('_')>-1){
            this.haveError = true;
            this.errorMessage = 'Неправильный формат даты';
            this.redraw();
            return ;
        }

        let date = moment(value, 'DD.MM.YYYY');

    

       // console.log('DatePicker::'+this.fieldName+'::setDateFromInput', value);
       

        if(date.isValid()){
            this.haveError = false
            this.selectDate = date ;
            this.setDate();
            this._model = this.selectDate.format('DD.MM.YYYY')
            
            if(this.$datepicker){
           
                this.$datepicker.hide();
            }

        }else{
            this.haveError = true;
            this.errorMessage = 'Неправильный формат даты';
            this._model = null
            this.selectDate = null;
            
            if(this.$datepicker){
           
                this.$datepicker.show();
            }

        }
        this.redraw();

    }
    change(/*event*/){
      //  console.log(event, event);
        this.setDateFromInput(this.$input.val());
    }
    
    onTypeEnd(value){
        this.setDateFromInput(value);
    }
    onKeyDown(){
        if(!this.masked){
            this.$input.mask('99.99.9999', {
                placeholder: "_"
            });
            this.masked = true
        }
    }
    onKeyup(event){
        
        this.haveError = false;
        this.errorMessage = false;

       // console.log('onkeyUp', event);
        if(this.timer){
            clearTimeout(this.timer);
        }

        setTimeout(this.onTypeEnd.bind(this, event.currentTarget.value), 300);
    }
   

    onSelectDate (formattedDate/*, date, inst*/){

        if(!formattedDate){
            return ;
        }
     /*   console.log('DatePicker::'+this.fieldName+'::selectDate',{
            formattedDate:formattedDate, 
            date:date
        });
        */
        this.haveError = false;
        this.masked = false 

        if(!this.$input){
            return
        }

        this.$input.trigger('unmask');
        this.$input.val(formattedDate)
        this.$input.trigger('change');
    }






    $postLink() {
        super.$postLink();
        
        let param = {
            onSelect: this.onSelectDate.bind(this)
        };
        
        if(this.onlyFuture){
            debugger
            param.minDate = new Date()
        }

        this.$datepicker  = $("input.form--control-date", this.$element).datepicker(param).data('datepicker');
        
        if(this.selectDate){
            this.$datepicker.selectDate( this.selectDate.toDate())
        }

        this.$input = $("input", this.$element);
        this.$input.on('keyup', this.onKeyup.bind(this))
        this.$input.on('keydown', this.onKeyDown.bind(this))
       

    }

    onSaveForm  (event, data){
        if(!this.notAllowEmpty){
           return;
        }
        if(!this.model){
            data.haveError(this);
        }
    }




}

class inputDatePickerWithSwitchController extends inputDatePickerController{
    static get $inject(){ return   ["$element", '$log', '$scope']}

    constructor($element, $log, $scope) {
        super($element, $log, $scope)
        
        this.textDisable="text-not";
        this.textEnable="text-yes";
        this.__disableModel = false; 
    }

    get disableModel(){
       return  this.__disableModel 
    }

    set disableModel(value){
        this.__disableModel = value
        this.haveError = false;
        if(value){
            this.model=null;
        }
        if(this.$datepicker){
           
            this.$datepicker.hide();
        }
    }
   

}
export { 
    inputDatePickerController,
    inputDatePickerWithSwitchController
};


// WEBPACK FOOTER //
// ./src/components/elements/input.date.picker.controller.js